<ng-container *transloco="let t">
  <div
    class="signPolicyDialog"
    *ngIf="!loading">
    <h2 class="signPolicyDialog__header">
      {{ t('apk.summaryForm.signPolicyDialog.header1') }}
      <span
        [ngClass]="
          isWarrantyGap
            ? 'signPolicyDialog__header--green'
            : 'signPolicyDialog__header--yellow'
        "
        class=""
        >{{ t('apk.summaryForm.signPolicyDialog.header2') }}</span
      >
    </h2>

    <div class="signPolicyDialog__content">
      <form
        class="signPolicyDialog__content__form"
        [formGroup]="form"
        (submit)="signPolicy()">
        <div class="signPolicyDialog__content__form__control">
          <p-inputMask
            [styleClass]="isWarrantyGap ? 'isGreen' : ''"
            type="text"
            formControlName="code"
            mask="******"
            [maxlength]="6"
            slotChar=""
            [autoClear]="true"
            (click)="this.form.controls.code.reset()"
            placeholder="{{
              t('apk.summaryForm.signPolicyDialog.codeInputPlaceholder')
            }}"></p-inputMask>
        </div>

        <button
          type="submit"
          [ngClass]="isWarrantyGap ? 'buttonGreen' : 'buttonYellow'"
          class="signPolicyDialog__content__form__button"
          [disabled]="form.invalid">
          <span class="signPolicyDialog__content__button__label">{{
            t('apk.summaryForm.signPolicyDialog.signButton')
          }}</span>
        </button>
      </form>

      <ng-container *ngIf="isWarrantyGap">
        <p class="signPolicyDialog__content__description">
          {{ t('apk.summaryForm.signPolicyDialog.description1Warranty') }}
        </p>

        <p
          class="signPolicyDialog__content__description signPolicyDialog__content__description--small"
          [innerHTML]="
            t('apk.summaryForm.signPolicyDialog.description2Warranty')
          "></p>

        <p class="signPolicyDialog__content__description">
          {{ t('apk.summaryForm.signPolicyDialog.note1Warranty') }}
          <a [href]="'mailto:' + t('apk.summaryForm.signPolicyDialog.note2')">{{
            t('apk.summaryForm.signPolicyDialog.note2Warranty')
          }}</a>
        </p>
      </ng-container>

      <ng-container *ngIf="!isWarrantyGap">
        <p class="signPolicyDialog__content__description">
          {{ t('apk.summaryForm.signPolicyDialog.description1') }}
        </p>

        <p class="signPolicyDialog__content__description">
          {{ t('apk.summaryForm.signPolicyDialog.description2') }}
        </p>

        <button
          type="submit"
          class="buttonWhite signPolicyDialog__content__button"
          (click)="getAttachments()">
          <span class="signPolicyDialog__content__button__label">{{
            t('apk.summaryForm.signPolicyDialog.downloadAttachmentsButton')
          }}</span>
        </button>

        <p
          class="signPolicyDialog__content__description signPolicyDialog__content__description--small">
          {{ t('apk.summaryForm.signPolicyDialog.note1') }}
          <a [href]="'mailto:' + t('apk.summaryForm.signPolicyDialog.note2')">{{
            t('apk.summaryForm.signPolicyDialog.note2')
          }}</a>
        </p>
      </ng-container>
    </div>
    <button
      type="button"
      class="signPolicyDialog__exit"
      (click)="handleDialogClose()">
      X
    </button>
  </div>
  <div
    class="signPolicyDialog__content__spinner"
    *ngIf="loading">
    <p-progressSpinner></p-progressSpinner>
    <p class="signPolicyDialog__content__description">
      {{ t('apk.summaryForm.signPolicyDialog.loading') }}
    </p>
  </div>
</ng-container>
